/* NewEden2.0 — variant-picker.js
   <variant-picker>: reads option radios, matches a variant from the
   embedded JSON, updates hidden id input, price, availability, URL,
   and notifies the media gallery to switch to the variant image. */
(function () {
  'use strict';
  var NE = window.NewEden || {};
  var isEnglish = document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('en') === 0;
  var englishValues = {
    Schwarz: 'Black',
    Babyblau: 'Baby blue',
    Weiß: 'White',
    Weiss: 'White',
    Blau: 'Blue',
    Rot: 'Red',
    Grün: 'Green',
    Gruen: 'Green',
    Grau: 'Gray',
    Dunkelblau: 'Navy',
    Burgunder: 'Burgundy'
  };

  function localizedValue(value) {
    return isEnglish && englishValues[value] ? englishValues[value] : value;
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', class extends HTMLElement {
      constructor() {
        super();
        this.onChangeBound = this.onChange.bind(this);
        this.onValueClickBound = this.onValueClick.bind(this);
      }

      connectedCallback() {
        if (this.isInitialised) return;
        this.section = this.dataset.section;
        this.url = this.dataset.url;
        var json = this.querySelector('[data-variant-json]');
        try { this.variants = json ? JSON.parse(json.textContent) : []; } catch (e) { this.variants = []; }
        this.select = this.querySelector('.variant-picker__select');
        this.addEventListener('change', this.onChangeBound);
        this.addEventListener('click', this.onValueClickBound);
        this.isInitialised = true;
      }

      disconnectedCallback() {
        if (!this.isInitialised) return;
        this.removeEventListener('change', this.onChangeBound);
        this.removeEventListener('click', this.onValueClickBound);
        this.isInitialised = false;
      }

      get selectedOptions() {
        var selected = [];
        this.querySelectorAll('.variant-picker__input:checked').forEach(function (input) {
          var position = parseInt(input.dataset.optionPosition, 10);
          if (position > 0) selected[position - 1] = input.value;
        });
        return selected;
      }

      onValueClick(e) {
        var value = e.target.closest('.variant-picker__value');
        if (!value || !this.contains(value)) return;
        var input = this.querySelector('#' + CSS.escape(value.htmlFor));
        if (!input || input.disabled) return;
        e.preventDefault();
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onChange(e) {
        if (!e.target.matches('.variant-picker__input')) return;
        // reflect selected label
        var group = e.target.closest('.variant-picker__option');
        if (group) {
          var label = group.querySelector('[data-selected-value]');
          if (label) label.textContent = localizedValue(e.target.value);
        }
        this.updateVariant();
      }

      updateVariant() {
        var sel = this.selectedOptions;
        var match = this.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
        if (this.select) {
          this.select.value = match ? match.id : '';
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateHiddenInputs(match);
        this.updatePrice(match);
        this.updateAvailability(match);
        this.updateURL(match);
        this.updateMedia(match);
        NE.emit && NE.emit(NE.PUB.variantChange, { variant: match, section: this.section });
      }

      updateHiddenInputs(variant) {
        var form = document.querySelector('#product-form-' + this.section + ', [data-section="' + this.section + '"] form');
        if (!form) form = document.querySelector('product-form[data-section="' + this.section + '"] form');
        if (!form) return;
        var input = form.querySelector('[data-variant-id], input[name="id"]');
        if (input) input.value = variant ? variant.id : '';
      }

      updatePrice(variant) {
        var holder = document.querySelector('[data-price-wrapper="' + this.section + '"]') ||
                     document.querySelector('[data-section-id="' + this.section + '"] [data-price-wrapper]');
        if (!holder || !variant) return;
        var price = holder.querySelector('[data-price]');
        var compare = holder.querySelector('[data-compare-price]');
        if (price) price.textContent = NE.formatMoney(variant.price);
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = NE.formatMoney(variant.compare_at_price);
            compare.hidden = false;
            holder.classList.add('is-on-sale');
          } else { compare.hidden = true; holder.classList.remove('is-on-sale'); }
        }
      }

      updateAvailability(variant) {
        var btn = document.querySelector('[data-section="' + this.section + '"] [data-add-to-cart]') ||
                  document.querySelector('#product-form-' + this.section + ' [data-add-to-cart]');
        if (!btn) return;
        var label = btn.querySelector('[data-add-label]');
        var addText = ((NE.strings && NE.strings.addToCart) || 'Add to cart').toUpperCase();
        var soldOut = (NE.strings && NE.strings.soldOut) || 'Ausverkauft';
        var unavailable = (NE.strings && NE.strings.unavailable) || 'Unavailable';

        if (!variant) {
          btn.disabled = true;
          if (label) label.innerHTML = '<span class="product-form__submit-main">' + unavailable + '</span>';
        } else if (!variant.available) {
          btn.disabled = true;
          if (label) label.innerHTML = '<span class="product-form__submit-main">' + soldOut.toUpperCase() + '</span>';
        } else {
          btn.disabled = false;
          var btnPrice = btn.querySelector('[data-btn-price]');
          var delivery = btn.querySelector('.product-form__submit-sub');
          var deliveryHTML = delivery ? delivery.outerHTML : '';
          if (label) {
            label.innerHTML =
              '<span class="product-form__submit-main">' + addText +
              ' <span class="product-form__btn-sep">•</span> ' +
              '<span class="product-form__btn-price" data-btn-price>' + NE.formatMoney(variant.price) + '</span></span>' +
              deliveryHTML;
          } else if (btnPrice) {
            btnPrice.textContent = NE.formatMoney(variant.price);
          }
        }
        var stickyPrice = document.querySelector('[data-price-wrapper="sticky-' + this.section + '"] [data-price]');
        if (stickyPrice && variant) stickyPrice.textContent = NE.formatMoney(variant.price);
      }

      updateURL(variant) {
        if (!variant || !this.url) return;
        window.history.replaceState({}, '', this.url + '?variant=' + variant.id);
      }

      updateMedia(variant) {
        if (!variant || variant.featured_media == null) return;
        var gallery = document.querySelector('media-gallery[data-section="' + this.section + '"]');
        if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(variant.featured_media.id);
      }
    });
  }

  /* ---- <media-gallery> ---- */
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
      constructor() {
        super();
        this.slides = this.querySelectorAll('.product-gallery__slide');
        this.thumbs = this.querySelectorAll('.product-gallery__thumb');
        this.thumbs.forEach((t) => {
          t.addEventListener('click', () => this.setActiveMedia(t.getAttribute('data-media-id')));
        });
      }
      setActiveMedia(id) {
        this.slides.forEach((s) => s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id)));
        this.thumbs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)));
        var active = this.querySelector('.product-gallery__slide.is-active');
        if (active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  }
})();
